/* ============================================================
   RakstarJerseys custom premium layer — scroll reveal
   ============================================================ */
(function () {
  function init() {
    var sections = document.querySelectorAll('#MainContent > .shopify-section');
    if (!sections.length || !('IntersectionObserver' in window)) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('rks-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    sections.forEach(function (section, index) {
      // Skip the first section (hero) so it shows immediately on load
      if (index === 0) return;
      section.classList.add('rks-reveal');
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
